import {Box, Chip, Grid, IconButton, Typography} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
// import { useEffect, useState } from 'react';


const CustomPhonesUpload = ({
    label,
    col_size,
    required,
    onValueChange,
    value: propValue,
    errorMessage,
    isError
}) => {
    // const [phoneList, setPhoneList] = useState([]);

    // useEffect(() => {
    //     if (Array.isArray(propValue)) {
    //         setPhoneList(propValue);
    //     }
    // }, [propValue]);

    return (
        <Grid item xs={col_size}>
            <Typography style={{ fontSize: "14px", fontWeight: "600", lineHeight: "18px", marginBottom: "16px" }}>
                {label}
                {required && <span style={{ color: "red", marginLeft: "5px" }}>*</span>}
            </Typography>

            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, borderRadius: 2, border: "1px solid #e0e0e0", p: 1, position: "relative", height: 95, overflowY: "auto"} }>
                {(Array.isArray(propValue) && 
                    propValue.map((phone, idx) => (
                        <Chip key={idx} label={phone} onDelete={() => {
                                // setPhoneList((prev) =>
                                //     prev.filter((_, i) => i !== idx)
                                // );
                                onValueChange((prev) =>
                                    prev.filter((_, i) => i !== idx)
                                );
                            }}
                            sx={{ m: 0.5 }}
                        />
                    )
                ))}
                <IconButton color="primary" component="label" variant="text" sx={{ position: "sticky", bottom: 0, right: 0, zIndex: 1, marginLeft: "auto" }}>
                    <UploadFileIcon />
                    <input
                        type="file"
                        accept=".csv,.txt"
                        hidden
                        onChange={async (e) => {
                            const file = e.target.files[0];
                            if (!file) return;
                            const text = await file.text();
                            // Split by comma, newline, or semicolon, trim, and filter empty
                            const phones = text
                                .split(/[\n,;]+/)
                                .map((p) => p.trim())
                                .filter((p) => p.length > 0)
                                .map((p) => p[0] === "0" ? p.slice(1) : p);
                            // setPhoneList(phones);
                            onValueChange(phones);
                            e.target.value = "";
                        }}
                    />
                </IconButton>                
            </Box>
            <Typography variant="caption" color="error" style={{ marginTop: "5px", marginLeft: "0" }}>
                {isError ? errorMessage : ""}
            </Typography>            
        </Grid>
    );
}

export default CustomPhonesUpload;